import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { NUMBER_DIRECTIONS } from "../../utils/bondNumbersHelpers";

const BondNumbersPickSelector = ({ value, onChange, disabled = false }) => (
  <div className="bnums-pick-row" role="group" aria-label="Higher or lower">
    {NUMBER_DIRECTIONS.map((direction) => {
      const active = value === direction.id;
      const isHigher = direction.id === "higher";
      return (
        <button
          key={direction.id}
          type="button"
          className={`bnums-pick-btn${active ? " active" : ""}${isHigher ? " higher" : " lower"}`}
          disabled={disabled}
          onClick={() => onChange(direction.id)}
        >
          {isHigher ? <ArrowUp size={14} strokeWidth={2.5} /> : <ArrowDown size={14} strokeWidth={2.5} />}
          {direction.label}
        </button>
      );
    })}
  </div>
);

export default BondNumbersPickSelector;
